import script from "./GetCountdown.vue?vue&type=script&setup=true&lang=js"
export * from "./GetCountdown.vue?vue&type=script&setup=true&lang=js"

import "./GetCountdown.vue?vue&type=style&index=0&id=1da54f5a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1da54f5a"]])

export default __exports__